import Vue from "vue";

Vue.directive('toggle-social-share', {

    bind(el) {
        el.onclick = function(event) {
            $(el).next().toggleClass('single__share-container--hidden');
        };
    },
});

